import React, { useState } from "react"
import { Grid, Typography, useTheme } from "@mui/material"
import VIPTable from "./VIPTable"
import { useSelector } from "react-redux"
import Edit from "@mui/icons-material/EditRounded"
import DoneIcon from "@mui/icons-material/DoneRounded"
import ClearIcon from "@mui/icons-material/ClearRounded"
import { useDispatch } from "react-redux"
import { editVIPUserAction } from "redux/DMV/actions/user"
import { toast } from "react-toastify"

const ChooseCorrectVIP = ({ selectedRows, setSelectedRows }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { VIPProfileList } = useSelector((state) => state?.dmv)
  const originalData = VIPProfileList.map((vip) => vip.data).flat()
  const [editableRows, setEditableRows] = useState(originalData)
  const [editUserId, setEditUserId] = useState(null)

  const handleCancelEdit = () => {
    setEditUserId(null)
    setEditableRows([])
  }

  const handleEditUser = () => {
    const vipData = VIPProfileList.find((vip) => vip.id === editUserId)?.data || []

    const updatedRows = editableRows.filter((row) => {
      const original = vipData.find((item) => item.id === row.id)
      return (
        original &&
        (original.designation !== row.designation || original.work_company !== row.work_company)
      )
    })

    if (!updatedRows.length) {
      toast.error("Please update any profile", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      return
    }

    const { id, designation, work_company } = updatedRows[0]

    dispatch(
      editVIPUserAction({
        vipId: id,
        payload: { designation, work_company }
      })
    )

    setEditUserId(null)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h2Italic" color={theme.palette.text.secondary}>
          Step-2
        </Typography>
      </Grid>
      {VIPProfileList?.map((VIP, index) => (
        <React.Fragment key={VIP.id}>
          <Grid container item xs={12} justifyContent={"space-between"} alignItems={"center"}>
            <Grid xs={6} container gap={2} alignItems={"center"}>
              <Typography variant="body4Regular" color={theme.palette.text.secondary}>
                {`Select Correct VIP - ${VIP.name}`}
              </Typography>
              {editUserId !== VIP.id && (
                <Edit
                  onClick={() => {
                    setEditUserId(VIP.id)
                    setEditableRows([...VIP.data])
                  }}
                />
              )}
            </Grid>
            {editUserId === VIP.id && (
              <Grid xs={6} container gap={2} justifyContent={"flex-end"}>
                <DoneIcon color="success" onClick={handleEditUser} />
                <ClearIcon color="error" onClick={() => handleCancelEdit()} />
              </Grid>
            )}
          </Grid>
          <Grid item xs={12}>
            <VIPTable
              columns={columns}
              rows={VIP?.data}
              selectedRow={selectedRows[index]?.vip_id}
              setSelectedRow={(id) =>
                setSelectedRows((prev) => {
                  const newSelectedRows = [...prev]
                  newSelectedRows[index] = { vip_id: id, id: VIP.id }
                  return newSelectedRows
                })
              }
              editUser={editUserId === VIP.id}
              editableRows={editableRows}
              setEditableRows={setEditableRows}
            />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  )
}
export default ChooseCorrectVIP

const columns = [
  { id: "1", label: "Image", minWidth: 30 },
  { id: "2", label: "Name", minWidth: 180 },
  { id: "3", label: "Company", minWidth: 300 },
  { id: "4", label: "Role", minWidth: 400 },
  { id: "4", label: "Google Links", minWidth: 400 }
]
